var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.typeGame === 'unity')?_c('div',{staticClass:"ovi"},[_c('b-button',{staticClass:"my-2",attrs:{"type":"is-primary"},on:{"click":_vm.sendText}},[_vm._v(" Comenzar ")]),_c('unity',{ref:"myInstance",attrs:{"src":_vm.src,"unityLoader":_vm.unityLoader}})],1):(_vm.typeGame === 'gobot')?_c('div',[_c('godot')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }